import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { JourneyContext } from '../../../Contexts/JourneyContext'

import './LockedResource.css';
import Popup from '../../App/Common/Popup/Popup';


const LockedResource = () => {
    let navigate = useNavigate();
    const { setCurrentPlace } = useContext(JourneyContext)
    useEffect(() => {
        setCurrentPlace({title: 'Ресурс заблокирован'})

    }, []);
    const onClick = () => {
        navigate(`/`, { replace: true });

    }

    return (

        <Popup onClose={onClick} title={'Доступ к ресурсу'} onClickAction={onClick} buttonText={'Понятно'} >
            <div className='lockedResource__body'>
                На данный момент ресурс недоступен
            </div>
        </Popup>
    )
}
export default LockedResource
